import { Component, Input, inject } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApiHeldFunds, getDisplayHoldType } from 'core';
import { LocalDateTimePipe } from '../../commons/pipes/locale.date.time.pipe';

@Component({
  selector: 'app-fund-details',
  templateUrl: 'fund-details.component.html',
  styleUrls: ['fund-details.scss'],
  imports: [LocalDateTimePipe],
})
export class FundDetailsComponent {
  private modalService = inject(BsModalService);

  readonly getDisplayHoldType = getDisplayHoldType;
  @Input() fundDetails: Array<ApiHeldFunds>;

  hideModal(): void {
    this.modalService.hide();
  }
}
